import PlatformBetNSettleTestScenarios from './PlatformBetNSettleTestScenarios'

/* eslint-disable camelcase, no-await-in-loop */
export default class JOKERTestScenarios extends PlatformBetNSettleTestScenarios {
  async betNSettleWin() {
    await this.setTestScenario(
      async () => {
        const { betAmount } = await this.formData
        await this.requests.getBalance()
        await this.requests.betNSettleWin({ data: { betAmount: 0, winAmount: betAmount * 1.5 } })
        await this.requests.getBalance({ action: 'betNSettle' })
      },
    )
  }

  async betNSettleWin5Times() {
    await this.setTestScenario(
      async () => {
        const { betAmount } = await this.formData
        await this.requests.getBalance()
        for (let timesLoop = 0; timesLoop < 5; timesLoop += 1) {
          await this.requests.betNSettleWin({ timesLoop, data: { betAmount: 0, winAmount: betAmount * 1.5 } })
        }
        await this.requests.getBalance({ action: 'betNSettle' })
      },
    )
  }

  async asyncBetNSettleWin5Times() {
    await this.setTestScenario(
      async () => {
        const { betAmount } = await this.formData
        await this.requests.getBalance()

        await Promise.all(Array.from({ length: 5 }).map(async (_, timesLoop) => {
          await this.requests.betNSettleWin({
            timesLoop,
            data: { betAmount: 0, winAmount: betAmount * 1.5 },
            options: { isAsync: true },
          })
          return true
        }))

        await this.requests.getBalance({ action: 'asyncBetNSettle' })
      },
    )
  }

  async betNSettleWin_cancelBetNSettle() {
    await this.setTestScenario(
      async () => {
        const { betAmount } = await this.formData
        await this.requests.getBalance()
        await this.requests.betNSettleWin({ data: { betAmount: 0, winAmount: betAmount * 1.5 } })
        await this.requests.getBalance({ action: 'betNSettle' })
        await this.requests.cancelBetNSettle()
        await this.requests.getBalance({ action: 'cancelBetNSettle' })
      },
    )
  }

  async betNSettleWin_cancelBetNSettle5Times() {
    await this.setTestScenario(
      async () => {
        const { betAmount } = await this.formData
        await this.requests.getBalance()
        await this.requests.betNSettleWin({ data: { betAmount: 0, winAmount: betAmount * 1.5 } })
        await this.requests.getBalance({ action: 'betNSettle' })
        for (let timesLoop = 0; timesLoop < 5; timesLoop += 1) {
          await this.requests.cancelBetNSettle({ timesLoop })
        }
        await this.requests.getBalance({ action: 'cancelBetNSettle' })
      },
    )
  }
}
